import React from "react"
import { Link } from "gatsby"
import facebook from "../../assets/images/social-icons/facebook-icon.svg"
import tiktok from "../../assets/images/social-icons/TikTok.svg"
import twitter from "../../assets/images/social-icons/twitter-icon.svg"
import linkedin from "../../assets/images/social-icons/linkedin-icon.svg"
import instagram from "../../assets/images/social-icons/instagram-icon.svg"
import youtube from "../../assets/images/social-icons/youtube-icon.svg"
import pinterest from "../../assets/images/social-icons/pinterest-icon.svg"

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer-area bg-color">
      <div className="container">
        <div className="container-sm container-xs">
          <div className="row">
            <div className="col-lg-1 col-sm-0 extra-col"></div>
            <div className="col-lg-2 col-sm-6">
              <div className="single-footer-widget">
                <h6>BlueMail</h6>
                <ul className="footer-links-list">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/download/">Download</Link>
                  </li>
                  <li>
                    <Link to="/security/">Security Center</Link>
                  </li>
                  <li>
                    <Link to="/corporate/">BlueMail Work</Link>
                  </li>
                  <li>
                    <Link to="/pricing/">Pricing</Link>
                  </li>
                  <li>
                    <Link to="/cross-platform/">Cross Platform</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2 col-sm-6">
              <div className="single-footer-widget">
                <h6>Features</h6>

                <ul className="footer-links-list">
                  <li>
                    <Link to="/features-functions/share/">Share</Link>
                  </li>
                  <li>
                    <Link to="/features-functions/clusters/">Clusters</Link>
                  </li>
                  <li>
                    <Link to="/bluechat/">BlueChat</Link>
                  </li>
                  <li>
                    <Link to="/calendar/">Calendar</Link>
                  </li>
                  <li>
                    <Link to="/features-functions/unified-inbox/">
                      Unified Inbox
                    </Link>
                  </li>
                  <li>
                    <Link to="/features-functions/get-stuff-done/">
                      Get Stuff Done
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="single-footer-widget">
                <h6>Resources</h6>
                <ul className="footer-links-list">
                  <li>
                    <a href="https://bluemail.me/help">Help Center</a>
                  </li>
                  <li>
                    <Link to="/blog/">Blog</Link>
                  </li>
                  <li>
                    <Link to="/news/">News</Link>
                  </li>
                  <li>
                    <Link to="/press-kit/">Press Kit</Link>
                  </li>
                  <li>
                    <Link to="https://blix.net/">About Blix</Link>
                  </li>
                  <li>
                    <Link to="/contact-us/">Contact Us</Link>
                  </li>
                  <li>
                    <a href="/"></a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="single-footer-widget">
                <ul className="social-link">
                  <li>
                    <a
                      href="https://twitter.com/BlueMail"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img style={{maxWidth: '16px'}} src={twitter} alt="twitter" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/BlueMailApp/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={facebook} alt="facebook" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/bluemail_/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={instagram} alt="instagram" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/bluemail/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={linkedin} alt="linkedin" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/@bluemail/"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={youtube} alt="youtube" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.tiktok.com/discover/bluemail"
                      className="d-block"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={tiktok} alt="tiktok" />
                    </a>
                  </li>
                  {/* <li>
                                    <a href="https://pinterest.com/bluemail0413" className="d-block" target="_blank" rel="noreferrer">
                                        <img style={{padding: '10%'}} src={pinterest} alt="youtube" />
                                    </a>
                                </li> */}
                </ul>

                <ul className="terms-privacy-ul">
                  <li>
                    <Link to="/tos/">Terms of Service</Link>
                  </li>
                  <li>
                    <Link to="/privacy/">Privacy Policy</Link>
                  </li>
                  <li>
                    <a href="https://fair.bluemail.me/">Call for unity</a>
                  </li>
                  <li>
                    <Link to="/careers/">Careers</Link>
                  </li>
                  <li style={{ lineHeight: "19px" }}>&nbsp;</li>
                  <li>
                    <p>
                      ©{currentYear}{" "}
                      <a
                        target="_blank"
                        href="https://blix.net/"
                        rel="noreferrer"
                      >
                        Blix Inc.
                      </a>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
